/* eslint-disable import/prefer-default-export */
export const roles = [
  { key: 'AccountAdmin', value: 'Account Admin' },
  { key: 'User', value: 'User' }
];



// WEBPACK FOOTER //
// ./src/assets/data/roles/index.js